import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Stack, Typography } from '@mui/material';
import RenderItem from './RenderItem';
import { translateLabel } from 'services/Utilities/labelUtils';

const CriteriaTypeSection = ({ criteriaType, details, submissionDetails, isReadOnly = false }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const rootDetails = (details || []).filter(detail => !detail.parentCriteriaTypeDetail_Id);

  if (!criteriaType) return null;

  return (
    <Paper elevation={3} sx={{ p: { xs: 2, md: 3 }, borderRadius: 2 }}>
      <Stack spacing={2}>
        {/* Section Header */}
        <Box
          sx={theme => ({
            bgcolor:
              theme.palette.mode === 'dark' ? theme.palette.accent?.graphite || '#2B2B2B' : theme.palette.background.default,
            p: 2.5,
            borderBottom: `1px solid ${theme.palette.borderColor.dark}`,
          })}>
          <Typography variant="h2">{translateLabel(criteriaType.name, i18n.language)}</Typography>
          {!!criteriaType.description && (
            <Typography variant="caption" sx={{ color: theme => theme.palette.text.secondary }}>
              {translateLabel(criteriaType.description, currentLanguage)}
            </Typography>
          )}
        </Box>
        {rootDetails.map(detail => (
          <RenderItem key={detail.id} detail={detail} allDetails={details} isReadOnly={isReadOnly} />
        ))}

        {rootDetails.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            {t('submission.noDetails')}
          </Typography>
        )}

        {isReadOnly && (
          <Box sx={{ mt: 1 }}>
            <Typography variant="caption" color="text.secondary">
              {t('submission.readOnlyMode')}
            </Typography>
          </Box>
        )}
      </Stack>
    </Paper>
  );
};

export default CriteriaTypeSection;
